import React  from "react";
import css from "./App.css";
import Switch from "../common/Switch";
import PropTypes from 'prop-types';

const isWidgetEnabled = (studentViewConfig, widgetConfiguration) => studentViewConfig[widgetConfiguration]

const widgets = [
  {title: 'Calendar', type: 'calendar', configuration: 'showCalendarWidget', helpText: 'Displays appointments/group sessions, assignments, course sections, and notifications with due dates.'},
  {title: 'Notifications', type: 'notifications', configuration: 'showNotificationWidget', helpText: 'Displays flags, referrals, and to-dos that are visible to students.'},
  {title: 'My Connections', type: 'connection', configuration: 'showConnectionWidget', helpText: 'Displays all My Connections.'},
  {title: 'My Services', type: 'services', configuration: 'showServiceWidget', helpText: 'Only displays My Services (excludes Other Services).'},
]

const ShowItemsOnDashboardOptions = (props) => {
  return (
    <div>
      <div className={css['section-title']}>Show these items on the Dashboard:</div>
      {widgets.map(widget => (
        <div key={widget.type}>
          <div className={css["show-student-dashboard"]} data-role={widget.configuration}>
            <Switch
              aria-labelledby={`dashboard-${widget.type}`}
              checked={isWidgetEnabled(props.studentViewConfig, widget.configuration)}
              onChange={(checked) => props.toggleWidget(widget.configuration, checked)}
            />
            <label id={`dashboard-${widget.type}`}>{widget.title}</label>
          </div>
          {widget.helpText && <div className={css['help-text']}>{widget.helpText}</div>}
        </div>
      ))}
      <div className={css['section-more-information']}>*Please note that the Kudos widget always displays when the student has kudos.</div>
    </div>
  )
};

ShowItemsOnDashboardOptions.propTypes = {
  toggleWidget: PropTypes.func.isRequired,
  studentViewConfig: PropTypes.object.isRequired
};

export default ShowItemsOnDashboardOptions;
